import { render, staticRenderFns } from "./ProductSpace.vue?vue&type=template&id=56d77c5f&scoped=true"
import script from "./ProductSpace.vue?vue&type=script&lang=js"
export * from "./ProductSpace.vue?vue&type=script&lang=js"
import style0 from "./ProductSpace.vue?vue&type=style&index=0&id=56d77c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d77c5f",
  null
  
)

export default component.exports